import {action, observable} from "mobx";
import {date, offers, shipment} from "./index";
import cultureSettings from "./cultureSettings"




export default class OffersStore {
    constructor( ){
        this.active = [];
        this.history = [];
        this.offers = [
            new Offer(1000,"rape",8,8,new Date(2019, 6, 11, 0, 0, 0),'train'),
            new Offer(10000,"rape",8,8,new Date(2019, 6, 30, 0, 0, 0),'train'),
            new Offer(5000,"rape",8,8,new Date(2019, 6, 11, 0, 0, 0),'train'),
        ];
    }
        @observable active=[];
        @observable history=[];
        @observable offers=[
            // new Offer(1000,"soy",8,8,new Date(2017, 6, 11, 0, 0, 0),'train'),
            // new Offer(100,"rape",8,8,new Date(2017, 6, 30, 0, 0, 0),'train'),
            // new Offer(5000,"soy",8,8,new Date(2017, 6, 11, 0, 0, 0),'train'),
            // new Offer(600,"soy",8,8,new Date(2017, 6, 13, 0, 0, 0),'train'),
            // new Offer(200,"soy",8,8,new Date(2017, 6, 30, 0, 0, 0),'train')
        ];

        addNewOffer(weight,culture){
            this.offers.unshift(new Offer(weight,culture,cultureSettings[culture].baseMoisture, cultureSettings[culture].baseWaste,
                new Date(date.day.getFullYear(), date.day.getMonth(), date.day.getDate()+7+Math.floor(Math.random()*3), 0, 0, 0), 'train')
                )
        }
}

class Offer{
    @observable status;
    @observable rem;
    constructor(amount,culture,waste,moisture,date,type,status = 'new'){
        this.amount = amount;
        this.culture=culture;
        this.waste = waste;
        this.moisture = moisture;
        this.date = date;
        this.status = status;
        this.rem = amount;
        this.type=type;
    }

    @action decRem(dec){
        this.rem-=dec;
        if (this.rem <=0){
            this.setStatus('success');
        }
    }

    setStatus(status,type,endDate, culture, amount, moisture,waste){
        this.status = status;
        if(status === 'inprogress'){
            let dayIncome = new Date(date.day.getFullYear(),date.day.getMonth(),date.day.getDate(),0,0,0);
            shipment.addOutputTransport(type,culture,dayIncome,endDate, amount+40, cultureSettings[culture].baseMoisture, cultureSettings[culture].baseWaste,this);
        }
    }
}
//success
//failed
//inprogress


// WEBPACK FOOTER //
// ./src/shared/stores/offersStore.js